function initialState() {
    return ({ discountRules: null });
}

export function rules(state = initialState(), action) {
    switch (action.type) {
        case 'SET_DISCOUNT_RULES':
            return { ...state, discountRules: action.discountRules };
        default:
            return state;
    }
}
